export default "__VITE_ASSET__DAdWxE2s__"